import { iconRegistry } from '@ui/icons/iconRegistry.tsx';

type RouteGlyph = {
  /** Registry glyph to render. */
  name: string;
  /** Turn arrows are drawn bare; everything else sits in a coloured badge. */
  turn: boolean;
  /** Theme path for the badge colour. */
  colorToken: string;
};

/** Route icon IDs whose registry glyph has a different name. Every other ID is looked up as is. */
const REGISTRY_ALIASES = {
  'walk.movingwalkway': 'wayfinding.movingwalkway',
  'wayfinding.accessiblestairs': 'wayfinding.stairs',
  'wayfinding.accessiblestairs.down': 'wayfinding.stairs.down',
  'wayfinding.accessiblestairs.up': 'wayfinding.stairs.up',
  'wayfinding.end': 'gate',
  'wayfinding.security': 'security',
} as const;

const WALK_TOKEN = 'colors.primary';
const ERROR_GLYPH: RouteGlyph = { name: 'error', turn: false, colorToken: WALK_TOKEN };

const isAlias = (name: string): name is keyof typeof REGISTRY_ALIASES => Object.hasOwn(REGISTRY_ALIASES, name);
const isRegistered = (name: string) => Object.hasOwn(iconRegistry, name);

/** Route legs use the walking colour, transit legs the transit colour, and POI categories their own `categoryBadge*` token. */
const getColorToken = (name: string) => {
  const [group, kind] = name.split('.');
  if (group === 'wayfinding' && (kind === 'train' || kind === 'bus')) {
    return kind === 'train' ? 'colors.categoryBadgeWayfindingTrain' : 'colors.categoryBadgeWayfindingBus';
  }
  if (group === 'wayfinding' || group === 'walk') {
    return WALK_TOKEN;
  }
  return `colors.categoryBadge${group.charAt(0).toUpperCase()}${group.slice(1)}`;
};

export const getRouteStepGlyph = (name: string): RouteGlyph => {
  const glyph = isAlias(name) ? REGISTRY_ALIASES[name] : name;
  if (!isRegistered(glyph)) {
    return ERROR_GLYPH;
  }
  return { name: glyph, turn: glyph.startsWith('turn.'), colorToken: getColorToken(glyph) };
};
